var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBillPayment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 19,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8.97 0H1.03C.46 0 0 .492 0 1.1v16.8c0 .607.461 1.1 1.03 1.1h7.94c.568 0 1.03-.493 1.03-1.1V1.1C10 .491 9.538 0 8.97 0m-.191 17.247H1.22V1.568H8.78z"
})));
export default SvgBillPayment;